export type CompactTileVariant = 'discussions' | 'notes' | 'supply';

export type CardIconAccent =
  | 'indigo'
  | 'amber'
  | 'orange'
  | 'emerald'
  | 'teal'
  | 'cyan'
  | 'violet'
  | 'rose'
  | 'sky'
  | 'pink'
  | 'slate';

const COMPACT_TILE_ACCENT: Record<CompactTileVariant, CardIconAccent> = {
  discussions: 'indigo',
  notes: 'amber',
  supply: 'orange',
};

/** Без суффикса siteId: my-finances-card-42 → my-finances-card */
export function normalizeCardId(cardId: string): string {
  return cardId.replace(/-\d+$/, '');
}

const CARD_ID_ACCENT: Record<string, CardIconAccent> = {
  'questions-v2-card': 'indigo',
  'questions-card': 'indigo',
  'notes-card': 'amber',
  'supply-card': 'orange',
  'my-shift-v2-card': 'teal',
  'active-shifts-v2-card': 'emerald',
  'my-site-shifts-card': 'cyan',
  'site-shifts-card': 'cyan',
  'all-sites-shifts-card': 'cyan',
  'my-finances-card': 'violet',
  'my-finances-ledger-card': 'violet',
  'accounting-card': 'emerald',
  'executor-balances-card': 'violet',
  'payments-v2-card': 'rose',
  'managed-payments-card': 'rose',
  'user-payments-card': 'rose',
  'incoming-payments-v2-card': 'sky',
  'site-summary-card': 'pink',
  'stations-card': 'sky',
  'contracts-card': 'slate',
  'estimates-card': 'pink',
  'projects-v2-card': 'indigo',
  'members-card': 'slate',
  'profile-card': 'slate',
  'profile-card-skeleton': 'slate',
  'overall-statistics-card': 'indigo',
  'test-card': 'slate',
};

const FALLBACK_ACCENTS: CardIconAccent[] = [
  'indigo',
  'teal',
  'emerald',
  'cyan',
  'violet',
  'rose',
  'sky',
  'amber',
  'orange',
  'pink',
];

function hashAccent(cardId: string): CardIconAccent {
  let hash = 0;
  for (let i = 0; i < cardId.length; i += 1) {
    hash = (hash + cardId.charCodeAt(i)) % FALLBACK_ACCENTS.length;
  }
  return FALLBACK_ACCENTS[hash] ?? 'slate';
}

export function resolveCardIconAccent(
  cardId: string,
  compactTileVariant?: CompactTileVariant,
  explicit?: CardIconAccent
): CardIconAccent {
  if (explicit) return explicit;
  if (compactTileVariant) return COMPACT_TILE_ACCENT[compactTileVariant];
  const baseId = normalizeCardId(cardId);
  return CARD_ID_ACCENT[baseId] ?? hashAccent(baseId);
}
